export const RETRIEVE_USERS_SUCCESS = 'RETRIEVE_USERS_SUCCESS';
export const UPDATE_ACCOUNT_ROLE_SUCCESS = 'UPDATE_ACCOUNT_ROLE_SUCCESS';
export const RETRIEVE_ACCOUNT_ROLES_SUCCESS = 'RETRIEVE_ACCOUNT_ROLES_SUCCESS';
export const CREATE_ACCOUNT_ROLE_SUCCESS = 'CREATE_ACCOUNT_ROLE_SUCCESS';
export const CREATE_APPLICATION_ROLE_SUCCESS = 'CREATE_APPLICATION_ROLE_SUCCESS';
export const RETRIEVE_APPLICATION_ROLES_SUCCESS = 'RETRIEVE_APPLICATION_ROLES_SUCCESS';
export const UPDATE_APPLICATION_ROLE_SUCCESS = 'UPDATE_APPLICATION_ROLE_SUCCESS';
export const CHANGE_USER_TABLE_PAGE_SIZE = 'CHANGE_USER_TABLE_PAGE_SIZE';